document.addEventListener('rebuy:cart.add', (event) => { 
  
  console.log('rebuy:cart.add event', event.detail.item); 
  var ProVariantID = event.detail.item.variant_id;
  var ProductVariantQty = event.detail.item.quantity;
  
  
const endpoint = 'https://house-ofleon.myshopify.com/api/2024-04/graphql';
const headers = new Headers({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'X-Shopify-Storefront-Access-Token': 'fb7d74bd378f93aa443f0fb8ee8ade42'
});

const getShopifyProductTypes = async () => {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ query: query() })
  });
  const data = await response.json();
  console.log(data.data.node.metafield.value);
  var MetaVal = data.data.node.metafield.value
  const newItem = event.detail.item;
  // Add your custom property to the item
  console.log("Variant Id: " + ProVariantID);
  console.log("Variant Qty: " + ProductVariantQty)
  console.log("Meta Value: " + MetaVal);
  
  let newText = MetaVal.replace(/Arriving to our warehouse:/, '');
  var NewUpdatedValue = newText.trim()
  console.log(NewUpdatedValue);
  let result = MetaVal.includes("Arriving to our warehouse:");

  let newTextReady = MetaVal.replace(/^In Stock \+ /, '').trim();
  //var NewUpdatedValueText = newTextReady.trim();
  console.log("New Ship value: " + newTextReady)
  //let result = MetaVal.includes("Arriving to our warehouse:");
  
  if(result){
    console.log("Is Arriving Text") 
    var ItemData = '{"id": "'+ProVariantID+'", "quantity": "'+ProductVariantQty+'", "properties":{ "Arriving to our warehouse":"'+NewUpdatedValue+'"}}';
  }else{
    console.log("Not Arriving Text") 
    var ItemData = '{"id": "'+ProVariantID+'", "quantity": "'+ProductVariantQty+'", "properties":{ "Availability":"'+newTextReady+'"}}';
  }
  
  
  $.ajax({
        url: "/cart/change.js",
        type: "POST",
        data: ItemData, 
        contentType: "application/json",
        dataType: 'json'
  });
}


const query = () => `{
  node(id: "gid://shopify/ProductVariant/${ProVariantID}") {
    ... on ProductVariant {
      id
      title
      metafield(namespace: "custom", key: "shippingdetails") {
        key
        value
      }
    }
  }
}`;

getShopifyProductTypes();


});
// console.log("========");
// Console.log(ProVariantID)
// console.log("========");





